import { OpaccAccount } from './classes/opacc.class.account.js';

export const opaccAccountPlugin = new OpaccAccount();